export const protobufPackage = "snapchat.cdp.cof";
export enum BenchmarkName {
    UNKNOWN_BENCHMARK = 0,
    CPU_GFLOPS = 1,
    GPU_GFLOPS = 2,
    GPU_GFLOPS_VECTOR = 3,
    GPU_SYSTEM_CAPABILITIES = 4,
    GPU_VERTEX_THROUGHPUT = 5,
    GPU_SIMPLE_GEOMETRY_THROUGHPUT = 6,
    GPU_GAUSSIAN_BLUR = 7,
    CPU_MEMORY_THROUGHPUT = 8,
    GPU_FILL_RATE = 9,
    MEM_TOTAL_MEMORY = 10,
    CPU_NUM_PROCESSORS = 11,
    DEVICE_INFORMATION_CHIPSET = 12,
    DEVICE_INFORMATION_BUILD_HARDWARE = 13,
    DEVICE_INFORMATION_BUILD_BRAND = 14,
    DEVICE_INFORMATION_BUILD_MANUFACTURER = 15,
    DEVICE_INFORMATION_BUILD_MODEL = 16,
    DEVICE_INFORMATION_SCREEN_PROPERTIES = 17,
    DEVICE_INFORMATION_CODEC_CAPABILITES = 18,
    CPU_PRIME_KOTLIN = 19,
    CPU_PRIME_NATIVE = 20,
    CPU_SQRT_KOTLIN = 21,
    CPU_SQRT_NATIVE = 22,
    CPU_INT_MATH_KOTLIN = 23,
    CPU_INT_MATH_NATIVE = 24,
    DEVICE_INFORMATION_GL_VERSION = 25,
    DEVICE_INFORMATION_GLSL_VERSION = 26,
    DEVICE_INFORMATION_OPENCL_EXISTS = 27,
    DEVICE_INFORMATION_IS_HOST_UNIFIED_MEMORY = 28,
    DEVICE_INFORMATION_OPENCL_VERSION = 29,
    DEVICE_INFORMATION_TIMING_RESOLUTION_NS = 30,
    DEVICE_INFORMATION_ADDRESS_SIZE = 31,
    DEVICE_INFORMATION_GPU_MAX_CLOCK_FREQUENCY_MHZ = 32,
    DEVICE_INFORMATION_COMPUTE_UNITS = 33,
    DEVICE_INFORMATION_MAX_WORKGROUP_SIZE = 34,
    DEVICE_INFORMATION_LOCAL_MEMORY_IS_LOCAL = 35,
    DEVICE_INFORMATION_LOCAL_MEMORY_SIZE = 36,
    DEVICE_INFORMATION_GLOBAL_MEMORY_CACHE_SIZE = 37,
    DEVICE_INFORMATION_GLOBAL_MEMORY_CACHELINE_SIZE = 38,
    DEVICE_INFORMATION_GL_HAS_FENCE_SYNC_OBJECT = 39,
    DEVICE_INFORMATION_HEXAGON_NN_LIBRARY_VERSION = 40,
    GPU_GFLOPS_V2 = 41,
    GPU_GFLOPS_VECTOR_V2 = 42,
    DEVICE_INFORMATION_GPU_MODEL = 43,
    DEVICE_INFORMATION_CODEC_CAPABILITES_V2 = 44,
    DEVICE_INFORMATION_MEDIA_PERFORMANCE_CLASS = 45,
    UNRECOGNIZED = -1
}
